







import { Component, Vue, Prop } from "vue-property-decorator";
import $ from "jquery";

// eslint-disable-next-line @typescript-eslint/no-var-requires
// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line @typescript-eslint/no-var-requires

@Component({})
export default class CarouselCard extends Vue {
  // eslint-disable-next-line class-methods-use-this

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  // eslint-disable-next-line class-methods-use-this
  @Prop({ required: true }) public text!: string;

  @Prop({ required: true }) public src!: string;

  @Prop({ required: true }) public className!: string;

  private showTitle(e: any) {
    e.target.parentNode.className = "external-container-active";
  }

  private showTitle2(e: any) {
    e.parentNode.className = "external-container-active";
  }

  scrollToTarget(e: any) {
    let name = this.src;
    if (this.src === "Missão") {
      name = "Missao";
    }
    e.target.className = `card-container ${name}`;
    this.showTitle(e);
  }

  scrollToTarget2(e: any) {
    let name = this.src;
    if (this.src === "Missão") {
      name = "Missao";
    }
    e.target.className = `card-container ${name}`;
    this.showTitle2(e.target.parentNode);
  }
}
